import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Loader from '../../generic-components/loader/Loader';
import ClayLayout from '@clayui/layout';
import {
    basicDetailsFields,
    contactDetailsFields,
    defaultValueForSelect,
    scopeKeyLeadManagement,
    seniorManagementDetailsFields
} from '../../utils/Config';
import FormComponent from '../../generic-components/formComponent/FormComponent';
import Button from '@clayui/button';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
    setIsChamberMember,
    setIsFormFilled,
    setMemberNumber
} from '../../slices/businessExpansionSlice';
import { setBusinessEmail } from '../../slices/commonSlice';
import axios from 'axios';
import { primaryButtonStyle, scrollToSection } from '../../utils/commonUtil';
import { otpService } from '../../services/otpService';
import { toast } from 'react-toastify';
import { expansionInquiryService } from '../../services/expansionInquiryService';

interface IAlreadyMemberDetail {
    setStep: React.Dispatch<React.SetStateAction<number>>;
}

const AlreadyMemberDetail: React.FC<IAlreadyMemberDetail> = ({ setStep }) => {
    // const { isFormFilled, isChamberMember } = useAppSelector(
    //     (state) => state.businessExpansion
    // );
    const formValues = useAppSelector((state) => state.businessExpansion);
    const commonValues = useAppSelector((state) => state.common);
    const [url, setUrl] = useState('');
    const [uploadLicense, setUploadLicense] = useState<File[]>([]);
    const [uploadMembership, setUploadMembership] = useState<File[]>([]);
    const [uploadCompanyProfile, setUploadCompanyProfile] = useState<File[]>(
        []
    );
    const fileHandling = {
        attachtradeLicenseDoc: {
            selectedFiles: uploadLicense,
            setSelectedFiles: setUploadLicense
        },
        attachMembershipDoc: {
            selectedFiles: uploadMembership,
            setSelectedFiles: setUploadMembership
        },
        attachCompanyProfile: {
            selectedFiles: uploadCompanyProfile,
            setSelectedFiles: setUploadCompanyProfile
        }
    };
    const {
        control,
        register,
        formState: { errors: formErrors },
        watch,
        handleSubmit,
        setError,
        setValue
    } = useForm<any>({
        mode: 'all',
        defaultValues: {
            ...formValues,
            ...commonValues,
            haveYouFill:
                formValues?.isFormFilled === false
                    ? 'no'
                    : formValues?.isFormFilled === true
                      ? 'yes'
                      : '',
            member:
                formValues?.isChamberMember === true
                    ? 'yes'
                    : formValues?.isChamberMember === false
                      ? 'no'
                      : ''
        }
    });
    const [loading, setLoading] = useState(false);
    const [dropdownOptions, setDropdownOptions] = useState<any>({});

    const dispatch = useAppDispatch();
    const haveYouFill = watch('haveYouFill');
    const member = watch('member');

    useEffect(() => {
        const updateDropdownOptions = async () => {
            const haveYouFillOpts = defaultValueForSelect;
            const memberOpts = defaultValueForSelect;

            setDropdownOptions((prevData: any) => ({
                ...prevData,
                haveYouFill: haveYouFillOpts,
                member: memberOpts
            }));
        };

        updateDropdownOptions();
    }, []);

    useEffect(() => {
        if (haveYouFill === 'yes') {
            dispatch(setIsFormFilled(true));
            dispatch(setIsChamberMember(null));
        } else if (haveYouFill === 'no') {
            dispatch(setIsFormFilled(false));
        } else {
            dispatch(setIsFormFilled(null));
        }
    }, [haveYouFill, dispatch]);

    useEffect(() => {
        if (member === 'yes') {
            dispatch(setIsChamberMember(true));
        } else if (member === 'no') {
            dispatch(setIsChamberMember(false));
        } else {
            dispatch(setIsChamberMember(null));
        }
    }, [member, dispatch]);

    const onSubmit = async (data: any) => {
        setLoading(true);
        if (haveYouFill === 'yes') {
            dispatch(setBusinessEmail(data.businessEmail || ''));
            dispatch(setMemberNumber(data.dcMembershipNumber || ''));
        }
        try {
            const response =
                (await expansionInquiryService.checkIsAlreadyFormFill(
                    data.businessEmail,
                    data?.dcMembershipNumber
                )) as {
                    success?: boolean;
                    message?: string;
                    data?: {
                        contactEmail?: string;
                        exists?: boolean;
                    };
                };

            if (response.success && response.data?.exists) {
                const response = await otpService.gerateOTP(
                    data?.businessEmail,
                    scopeKeyLeadManagement
                );
                if (response.statusCode === 200) {
                    toast.success(response.statusMessage, {
                        theme: 'light',
                        autoClose: 2000
                    });
                    setStep(1);
                    scrollToSection();
                }
            }
            if (response.success && !response.data?.exists) {
                toast.error(
                    `You have not previously filled out the form using ${data?.businessEmail} `,
                    {
                        theme: 'light',
                        autoClose: 2000
                    }
                );
            }
        } catch (err: any) {
            toast.error(err?.message || 'Failed to submit inquiry', {
                theme: 'light',
                autoClose: 4000
            });
        }
        // const response = await otpService.gerateOTP(data?.businessEmail);
        // if (response.statusCode === 200) {
        //     toast.success(response.statusMessage, {
        //         theme: 'light',
        //         autoClose: 2000
        //     });
        //     setStep(1);
        // }
        setLoading(false);
    };

    const haveYouFilledField = basicDetailsFields.find(
        (f) => f.name === 'haveYouFill'
    );
    const memberField = basicDetailsFields.find((f) => f.name === 'member');

    const businessEmailField = contactDetailsFields.find(
        (f) => f.name === 'businessEmail'
    );
    const memberNumberField = basicDetailsFields.find(
        (f) => f.name === 'dcMembershipNumber'
    );
    const remainingBasicFields = basicDetailsFields.filter(
        (f) => f.name !== 'haveYouFill' && f.name !== 'member'
    );

    useEffect(() => {
        // Function to fetch terms and conditions from the API
        const fetchTerms = async () => {
            try {
                const companyId = (
                    window as any
                ).Liferay.ThemeDisplay.getCompanyId();
                const configId =
                    'com.dubaichamber.configuration.LeadManagementIntranetSiteConfiguration'; // Replace with the actual configurationId

                // API call to fetch terms
                const response = await axios.get(
                    `/o/venue-reservation-rest/v1.0/portal-configuration`,
                    {
                        params: {
                            configurationId: configId,
                            companyId: companyId
                        },
                        headers: {
                            'x-csrf-token': (window as any)?.Liferay?.authToken
                        }
                    }
                );
                const fetchedTermsID =
                    response.data.configuration
                        .servicesPortalMembershipSiteURL || null;
                setUrl(fetchedTermsID);
            } catch (error) {
                console.error('Error fetching terms:', error);
            }
        };

        fetchTerms();
    }, []);
    return (
        <>
            {loading && <Loader />}
            <form onSubmit={handleSubmit(onSubmit)}>
                <ClayLayout.Row justify="start" className="basic_detail_form">
                    {haveYouFilledField && (
                        <ClayLayout.Col xl={6} lg={6} md={6} sm={6} xs={12}>
                            <FormComponent
                                {...haveYouFilledField}
                                register={register}
                                control={control}
                                errors={formErrors}
                                watch={watch}
                                setError={setError}
                                errorTitle={haveYouFilledField.errorMessage}
                                options={dropdownOptions['haveYouFill'] || []}
                            />
                        </ClayLayout.Col>
                    )}

                    {haveYouFill === 'yes' && (
                        <div className="previously-applied-fields">
                            {businessEmailField && (
                                <ClayLayout.Col
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={12}
                                >
                                    <FormComponent
                                        {...businessEmailField}
                                        register={register}
                                        control={control}
                                        errors={formErrors}
                                        watch={watch}
                                        setError={setError}
                                        errorTitle={
                                            businessEmailField.errorMessage
                                        }
                                        component={businessEmailField.component}
                                        options={[]}
                                    />
                                </ClayLayout.Col>
                            )}
                            {memberNumberField && (
                                <ClayLayout.Col
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={12}
                                >
                                    <FormComponent
                                        {...memberNumberField}
                                        register={register}
                                        control={control}
                                        errors={formErrors}
                                        watch={watch}
                                        setError={setError}
                                        errorTitle={
                                            memberNumberField.errorMessage
                                        }
                                        options={[]}
                                    />
                                </ClayLayout.Col>
                            )}
                        </div>
                    )}

                    {haveYouFill === 'no' && (
                        <>
                            {memberField && (
                                <ClayLayout.Col
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={12}
                                >
                                    <FormComponent
                                        {...memberField}
                                        register={register}
                                        control={control}
                                        errors={formErrors}
                                        watch={watch}
                                        setError={setError}
                                        errorTitle={memberField.errorMessage}
                                        options={
                                            dropdownOptions['member'] || []
                                        }
                                    />
                                </ClayLayout.Col>
                            )}
                        </>
                    )}
                </ClayLayout.Row>

                {haveYouFill === 'no' && member === 'yes' && (
                    <>
                        <h2 className="section-title">Basic Details:</h2>
                        <ClayLayout.Row
                            justify="start"
                            className="basic_detail_form"
                        >
                            {remainingBasicFields.map((field) => (
                                <ClayLayout.Col
                                    key={field.name}
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={12}
                                >
                                    <FormComponent
                                        {...field}
                                        register={register}
                                        control={control}
                                        errors={formErrors}
                                        watch={watch}
                                        setError={setError}
                                        errorTitle={field.errorMessage}
                                        options={
                                            dropdownOptions[field.name] || []
                                        }
                                        selectedFiles={
                                            fileHandling[
                                                field.name as keyof typeof fileHandling
                                            ]?.selectedFiles
                                        }
                                        setSelectedFiles={
                                            fileHandling[
                                                field.name as keyof typeof fileHandling
                                            ]?.setSelectedFiles
                                        }
                                    />
                                </ClayLayout.Col>
                            ))}
                        </ClayLayout.Row>

                        <h2 className="section-title">
                            Point of Contact Details:
                        </h2>
                        <ClayLayout.Row
                            justify="start"
                            className="basic_detail_form"
                        >
                            {contactDetailsFields.map((field) => (
                                <ClayLayout.Col
                                    key={field.name}
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    xs={12}
                                >
                                    <FormComponent
                                        {...field}
                                        register={register}
                                        control={control}
                                        errors={formErrors}
                                        watch={watch}
                                        setError={setError}
                                        errorTitle={field.errorMessage}
                                        selectedFiles={
                                            fileHandling[
                                                field.name as keyof typeof fileHandling
                                            ]?.selectedFiles
                                        }
                                        setSelectedFiles={
                                            fileHandling[
                                                field.name as keyof typeof fileHandling
                                            ]?.setSelectedFiles
                                        }
                                        options={[]}
                                    />
                                </ClayLayout.Col>
                            ))}
                        </ClayLayout.Row>

                        <h2 className="section-title">
                            Senior Management Details:
                        </h2>
                        <ClayLayout.Row
                            justify="start"
                            className="basic_detail_form"
                        >
                            {seniorManagementDetailsFields?.map((field) => {
                                const colSize =
                                    field?.name == 'companyPhysicalAddress'
                                        ? 12
                                        : 6;
                                return (
                                    <ClayLayout.Col
                                        key={field.name}
                                        xl={colSize}
                                        lg={colSize}
                                        md={colSize}
                                        sm={colSize}
                                        xs={12}
                                    >
                                        <FormComponent
                                            placeholder={field.placeholder}
                                            label={field.label}
                                            name={field.name}
                                            register={register}
                                            type={field.type}
                                            control={control}
                                            errors={formErrors}
                                            watch={watch}
                                            setError={setError}
                                            errorTitle={field.errorMessage}
                                            required={field?.required}
                                            selectedFiles={
                                                fileHandling[
                                                    field.name as keyof typeof fileHandling
                                                ]?.selectedFiles
                                            }
                                            setSelectedFiles={
                                                fileHandling[
                                                    field.name as keyof typeof fileHandling
                                                ]?.setSelectedFiles
                                            }
                                            component={field.component}
                                        />
                                    </ClayLayout.Col>
                                );
                            })}
                        </ClayLayout.Row>
                    </>
                )}
                {member === 'no' && (
                    <div style={{ fontSize: '14px', color: '#da1414' }}>
                        Note: A valid Dubai Chambers membership is required to
                        access this service.{' '}
                        <a href={url} target="_blank">
                            Click here{' '}
                        </a>
                        to apply for membership.
                    </div>
                )}
                {!(haveYouFill === 'no' && member === 'no') && (
                    <div className="basic-details-button-section">
                        <Button
                            type="submit"
                            className="bottom-cut"
                            style={primaryButtonStyle}
                        >
                            <span className="bottom-cut-span"></span>
                            Continue
                        </Button>
                    </div>
                )}
            </form>
        </>
    );
};

export default AlreadyMemberDetail;
